import React, { Component } from 'react'

import '../../css/progress-bar.css'

class UploadProgress extends Component {
    render() {
        const { message, completed } = this.props
        const completedCalc = 100 - completed
        return (
            <div className="upload-progress">
                <div className="progress-bar" style={{
                    right: `${completedCalc}%`
                }}></div>
                <div className="message">{message}</div>
            </div>
        )
    }
}

export default UploadProgress



// WEBPACK FOOTER //
// ./src/components/utils/UploadProgress.js